import React, { Component } from 'react';
import Genres from './Genres';

class EditGenres extends Component{
  constructor(props){
    super(props);
    this.state={
      genrearray:props.genrearray,
      genres:props.genrearray
    }
  }
  cancel(e){
    e.preventDefault();
    this.props.cancel();
  }
  testValue(x,array){
    for(let i=0; i<array.length; i++){
      if(x==array[i]){
        return true;
      }
    }
    return false;
  }
  removeValue(x,array){
    for(let i=0; i<array.length; i++){
      if(x==array[i]){
        array.splice(i,1);
      }
    }
  }
  updateGenres(e){
    e.preventDefault();
    const genres = this.refs.genresdesired.value.split(',');
    console.log('now genres are: ',genres);
    this.setState({
      genres
    });
  }
  addGenre(genre){
      let current_genres = this.refs.genresdesired.value.split(',');
          //loop through array and test if genre is already there
          //if yes, remove it:
         if(this.testValue(genre,current_genres)){
           this.removeValue(genre,current_genres);
         }else{
          //if no, push it to genres:
          current_genres.push(genre);
         //  console.log('current genres: ',current_genres);
          this.setState({
            genres:current_genres
          });
         }
         console.log('current genres: ',current_genres);
      //update the current genres array in state:
      this.setState({
        genres:current_genres
      });
      //display the current genres user has selected in the input
      current_genres = current_genres.join(',');
      this.refs.genresdesired.value=current_genres;

  }
  submit(e){
    this.props.updateGenres(this.state.genres)
    this.props.cancel();
  }
  render(){
    const updateGenres  = this.props.updateGenres;
    let genrearray = this.state.genrearray;
    let genres = genrearray.join(',');
    return(
      <div className="genre-edit">
        <div className="genre-modal clearfix">

          <form>
            <label for="genre-input">Genres Desired</label>
            <input onKeyUp={this.updateGenres.bind(this)} className="form-control" ref="genresdesired" type="text" defaultValue={genres} id="add-genre"></input>
            <div className="form-group add-genres">


            </div>

            <Genres addGenre={this.addGenre.bind(this)} />

            <button className="btn btn-primary" onClick={this.cancel.bind(this)}>Cancel</button>
            <button className="btn btn-primary" onClick={this.submit.bind(this)} type="submit">Submit</button>
          </form>
        </div>

      </div>
    );
  }
}

export default EditGenres;



// WEBPACK FOOTER //
// ./src/components/EditGenres.js